import SkeletonHidden from './skeleton-hidden';
import SkeletonLoading from './skeleton-loading';
import {SKELETON_ABC} from '../experiments';
import TestExposureOnce from '../test-exposure-once';

export const testExposure = new TestExposureOnce(SKELETON_ABC);
export {
    SkeletonHidden,
    SkeletonLoading,
    SKELETON_ABC
};


// WEBPACK FOOTER //
// ./src/universal/abacus/skeleton-abc/index.js